import React, { useEffect, useState, useCallback } from 'react'
import { useSearchParams } from 'react-router-dom'
import NavBar from '../components/landing/NavBar'
import Question from '../components/main/Question'
import LoadingWithTyping from '../components/utils/LoadingWithTyping'
import { generateQuestion } from '../helper/questionGenerationHelper'
import Finished from '../components/main/Finished'

function Demo() {
	const [view, setView] = useState("generating-article")
  const [questions, setQuestions] = useState()
  const [correctTotal, setCorrectTotal] = useState(0)
  const [searchParams] = useSearchParams();
  var lang = searchParams.get("lang") || "en";
  if (lang !== "en" && lang !== "jp") {
    lang = "en"; // default to English if invalid language
  }
	
	let mainView;
  
  const handleGenerateQuestion = useCallback(() => {
    setCorrectTotal(0)
    setView("generating-article")
    generateQuestion(lang).then((result) => {
      setQuestions(result)
      setView("answer-question")
    })
  }, [lang])

  function handleRestart(){
    setCorrectTotal(0)
    setView("answer-question")
  };

  function handleDone(){
    setView("done")
  }

  function handleCorrectAnswer(){
    setCorrectTotal(correctTotal + 1)
  }

	useEffect(() => {
    handleGenerateQuestion()
  }, [handleGenerateQuestion]);

	if (view === "generating-article"){
    mainView = (
      <LoadingWithTyping textSequence={[
        "Parsing article from web page...",
        "Generating multiple choice questions...",
        "You will be given up to 5 multiple choice question, depends on the article length.",
        "Good luck!! 😉"
      ]}/>
    )
		
	}else if (view === "answer-question"){
		mainView = (<Question questions={questions} handleDone={handleDone} handleCorrectAnswer={handleCorrectAnswer}/>)
	}else if (view === "done"){
    mainView = (<Finished numCorrect={correctTotal} numQuestions={questions.question.length}
       handleRestart={handleRestart} handleNewQuestion={handleGenerateQuestion}/>)
  }


  return (
    <div className='h-full'>
			<div className='width-screen'>
				<NavBar/>
			</div>
			<div className='w-auto flex justify-center items-center'>
				{mainView}
			</div>
		</div>
  )
}

export default Demo